<template>
  <List item-layout="vertical" size="small">
    <template v-for="(child, childIdx) in row">
      <!-- <template v-if="field.child.child && child[field.child.child.list]">
        <tableColumnChild
          :row="child[field.child.child.list]"
          :field="field"
          :fields="fields"
          :parent="row"
          :key="childIdx"
        ></tableColumnChild>
      </template> -->
      <ListItem style="text-align:center" :key="childIdx">
				<template v-if="field.child.btns">
					<Button
						v-for="(btn, btnIndex) in field.list"
					  style="margin-right: 5px"
					  size="small"
					  @click="
					    $page.handleMethod({
					      methods: field.methods,
					      name: btn.fnName || 'click',
					      field: btn,
					      row:child,
					    })
					  "
					  :key="btn.type"
					  v-bind="btn.bind"
					  :type="
					    isMethod(btn.bind && btn.bind.type, {
					      row:child,
					      field: btn,
					      btnList: field.list,
					    })
					  "
					  :disabled="
					    isMethod(btn.disabled, {
					      row:child,
					      field: btn,
					      fields,
					      btnList: field.list,
					    })
					  "
					  :icon="isMethod(btn.icon, { row:child, field, fields })"
					>
					  {{ isMethod(btn.name, { row:child, field, fields }) }}
					  <Icon
					    :type="
					      isMethod(btn.afterIcon, { row:child, field, fields })
					    "
					    size="14"
					    :color="
					      isMethod(btn.afterIconColor, {
					        row:child,
					        field,
					        fields,
					      })
					    "
					    v-if="btn.afterIcon"
					  />
					</Button>
				</template>
        <template
          v-else-if="
            !field.child.component ||
              (field.child.component &&
                child[field.key] &&
                field.methods &&
                field.methods.render && !field.child.noTip)
          "
        >
          <Tooltip
            style="width:100%"
            v-if="
              getLetterWidthFun(child[field.key], 14) + 20 >=
                (field.width ? field.width : field.minWidth)
            "
            :content="child[field.key]"
            placement="top"
            max-width="600"
            transfer
          >
            <div
              @click="
                handleMethod({
                  methods: field.methods,
                  name: field.fnName || 'click',
                  parent: parent,
                  row: child,
                  rowIndex: childIdx,
                  field,
                  fields
                })
              "
              :style="
                (field.methods &&
                (field.methods.fnName || field.methods['click'])
                  ? 'cursor: pointer;color:#2d8cf0;'
                  : '') +
                  'width:100%;height:18.5px;line-height：18.5px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;'
              "
            >
              {{ child[field.key] }}
            </div>
          </Tooltip>
          <div
            v-else
            @click="
              handleMethod({
                methods: field.methods,
                name: field.fnName || 'click',
                parent: parent,
                row: child,
                rowIndex: childIdx,
                field,
                fields
              })
            "
            :style="
              (field.methods && (field.methods.fnName || field.methods['click'])
                ? 'cursor: pointer;color:#2d8cf0;'
                : '') +
                'width:100%;height:24.5px;line-height：18.5px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;'
            "
          >
            {{
              $page.handleMethod({
                methods: field.methods,
                name: "render",
                row: child,
                field,
                value: child[field.key]
              }) || child[field.key]
            }}
          </div>
        </template>
        <Row justify="center" v-else-if="field.child.component === 'Upload'">
          <Col v-if="!field.child.isNoUpload" span="12">
            <Upload
              :action="
                isMethod(field.uploadBind && field.uploadBind.action, {}, '/')
              "
              :show-upload-list="false"
              v-bind="field.uploadBind"
              :before-upload="
                file =>
                  handleMethod({
                    methods: field.methods,
                    name: 'beforeUpload',
                    file,
                    parent: parent,
                    row: child,
                    rowIndex: childIdx,
                    field,
                    fields
                  })
              "
            >
              <Button v-bind="field.bind">{{$t('Upload')}}</Button>
            </Upload>
          </Col>
          <Col span="12">
            <Button
              type="primary"
              size="small"
              :disabled="!child[field.key]"
              @click="openUrl(child[field.key])"
              >{{ child[field.key] ? $t('show') : $t('No Upload') }}</Button
            >
          </Col>
        </Row>
        <component
          v-else-if="field.child.component"
          :is="isMethod(field.child.component)"
          v-model="child[field.key]"
          :row="child"
          :render="field.render"
          :field="field"
          :index="childIdx"
          v-bind="field.bind"
          v-on="field.on"
          :type="
            isMethod(field.bind && field.bind.type, {
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          :min="
            isMethod(field.bind && field.bind.min, {
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          :max="
            isMethod(field.bind && field.bind.max, {
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          :disabled="
            isMethod(field.disabled, {
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          :placeholder="
            handlePlaceholder(field, {
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @click="
            handleMethod({
              methods: field.methods,
              name: field.fnName || 'click',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @on-enter="
            handleMethod({
              methods: field.methods,
              name: 'on-enter',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @on-focus="
            handleMethod({
              methods: field.methods,
              name: 'on-focus',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @on-blur="
            handleMethod({
              methods: field.methods,
              name: 'on-blur',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @on-change="
            handleMethod({
              methods: field.methods,
              name: 'on-change',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @on-ok="
            handleMethod({
              methods: field.methods,
              name: 'on-ok',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @on-input="
            handleMethod({
              methods: field.methods,
              name: 'on-input',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @on-clear="
            handleMethod({
              methods: field.methods,
              name: 'on-clear',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @on-select="
            handleMethod({
              methods: field.methods,
              name: 'on-select',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
          @on-click="
            handleMethod({
              methods: field.methods,
              name: 'on-click',
              parent: parent,
              row: child,
              rowIndex: childIdx,
              field,
              fields
            })
          "
        >
          {{
            $page.handleMethod({
              methods: field.methods,
              name: "render",
              row: child,
              field,
              value: child[field.key]
            }) || child[field.key]
          }}
        </component>
        <div
          style="width:100%;height:24.5px;line-height：24.5px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
          v-else
        >
          {{ child[field.key] }}
        </div>
      </ListItem>
    </template>
  </List>
</template>
<script>
import { getLetterWidth } from "@/libs/tools.js";
export default {
  name: "tableColumnChild",
  inject: {
    $page: "$page",
    $table: "$table"
  },
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    field: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Array,
      default: () => []
    },
    parent: {
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    openUrl(url) {
      console.log(url);
      window.open(url, "_blank");
    },
    // 获取层数
    getLayers(field) {
      let str = "";
      if (field.layers) {
        for (let index = 0; index < field.layers; index++) {
          str += ".child";
        }
      } else {
        str = ".child";
      }
      console.log(str);
      return str;
    },
    getLetterWidthFun(str, fontSize) {
      return getLetterWidth(str, fontSize);
    },
    handleMethod({ methods, name, row, field, fields }) {
      if (methods && methods[name])
        return methods[name].call(this.$table, {
          ...arguments[0],
          row,
          fields,
          field
        });
    },
    handlePlaceholder(item, params) {
      let name = {
        Select: "select",
        DatePicker: "select"
      };
      return this.$page.isMethodDefault(
        item.placeholder,
        params,
        "Select " + item.key
      );
    },
    isMethodDefault(methods, params, df) {
      if (typeof methods === "function")
        return methods.call(this.$table, params);
      return df;
    },
    isMethod(methods, params, df) {
      if (typeof methods === "function")
        return methods.call(this.$table, params);
      return methods !== undefined ? methods : df;
    }
  }
};
</script>
<style>
.mytable-footer .col-red {
  color: red;
}
</style>
